import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './Faq.css';

// `ns` is the locale key holding the questions. scripts/build-sites.js builds
// each page's FAQPage schema from the same key, so what Google reads is
// exactly what is on screen.
function Faq({ ns = 'faq' }) {
  const { t, i18n } = useTranslation();
  const questions = Object.keys(t(`${ns}.items`, { returnObjects: true }) || {});

  return (
    <section id="faq" className="faq">
      <p className="section-eyebrow">{t(`${ns}.eyebrow`)}</p>
      <h2 className="faq-title">
        <Trans i18nKey={`${ns}.heading`} components={{ em: <em /> }} />
      </h2>

      <div className="faq-list">
        {questions.map(key => (
          /* <details> keeps this keyboard-accessible and open-on-find without JS */
          <details key={key} className="faq-item">
            <summary className="faq-question">{t(`${ns}.items.${key}.q`)}</summary>
            <p className="faq-answer">{t(`${ns}.items.${key}.a`)}</p>
          </details>
        ))}
      </div>

      {i18n.exists(`${ns}.footnote`) && <p className="faq-footnote">{t(`${ns}.footnote`)}</p>}
    </section>
  );
}

export default Faq;
